import { Fragment, useEffect, useRef, useState } from "react"
import { URL } from "src/libs/interfaces/layouts"
import GalleryDialog from "../gallery/GalleryDialog"
import { GalleryItem } from "../gallery/Gallery"
import { IDiary } from "@/modules/pe-fest-module/data/interfaces"
import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated" 

interface IThumbnail {
    item: IDiary    
    animated?: ANIMATED_STYLE[]
    animated_delay?: ANIMATE_DELAY | string | number
    gap?: number
}
const ThumbnailTile = ({item, ...props}: IThumbnail) : JSX.Element => {
    const [isOpen, setIsOpen] = useState( false )
    const [i, setI] = useState(0)
    if(!item.thumbnail && !!(item.images || [])?.length ) return <></> 
    const gallery = [ item.thumbnail, ...(item.images || []) ].filter(im => im?.indexOf("empty.png") === -1)
    const to = (i :number) => {
        setI(i)
        setIsOpen( true )
    }
    let _gallery : JSX.Element
    switch(gallery.length)
    {
        case 0:
            _gallery = <></>
            break
        case 1:
            _gallery = <Gallery1 gallery={gallery}  to={to} start={0} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            break
        case 2:
            _gallery = <Gallery2 gallery={gallery}  to={to} start={0} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            break
        case 3:
            _gallery = <Gallery3 gallery={gallery}  to={to} start={0} gap={props.gap} />
            break
        case 4:
            _gallery = <Gallery4 gallery={gallery}  to={to} start={0} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            break
        case 5:
            _gallery = <Gallery5 gallery={gallery}  to={to} start={0} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            break
        case 6:
            _gallery = <Gallery6 gallery={gallery}  to={to} start={0} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            break
        default:
            _gallery = <Gallery gallery={gallery}   to={to} start={0} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
    }
    return <>
        { _gallery }
        <GalleryDialog
            i={ i }
            data={ gallery }
            setI={ setI }
            isOpen={ isOpen }
            setIsOpen={ setIsOpen }
        />
    </>
}

export default ThumbnailTile

export interface IGalleryProps {
    gallery: (string | undefined)[]
    to: (i:number) => void
    forceLine?: boolean
    start: number
    animated?: ANIMATED_STYLE[]
    animated_delay?: ANIMATE_DELAY | string | number
    gap?: number
}
export const Gallery1 = (props:IGalleryProps) : JSX.Element => { 
    const [imageP, setImageP] = useState<number[]>([])
    const [refWidth, setRedWidth] = useState<number>(100)
    const start:number = props.start || 0
    const ref = useRef(null)
    useEffect(() => {
        const widths: number[] = []
        const height: number[] = []
        const p: number[] = []
        props.gallery.forEach( (g, i) => { 
            var img = new Image();
            img.onload = function() { 
                if(!this) return
                const _this: any = this as any 
                widths.push( _this.width ) 
                height.push( _this.height )
                p.push(_this.width / _this.height)  
                setImageP( p )
             }
            img.src = g!
        }) 
        const _ref: any  = ref.current as any
        setRedWidth( _ref.offsetWidth )
    }, [])
    return imageP[0] > 1
        ?
        <div className="vk-gallery" ref={ref} style={{gap: props.gap}} >
            {/* <img src={props.gallery[0]} alt={props.gallery[0]} style={{ width:refWidth }} className="thumbnail" /> */}
            <GalleryItem
                url={props.gallery[0] as URL}
                i={start}
                type="image"
                galleryId=""
                gallery={[]}
                width={ refWidth } 
                height={ refWidth / imageP[ 0 ] }
                to={props.to}
                animated={props.animated }
                animated_delay={props.animated_delay}
            />
        </div>
        :
        <div className="vk-gallery" ref={ref} style={{gap: props.gap}} >
            {/* <img src={props.gallery[0]} alt={props.gallery[0]} className="thumbnail" /> */}
            <GalleryItem
                url={props.gallery[0] as URL}
                i={start}
                type="image"
                galleryId=""
                gallery={[]} 
                to={props.to}
            />
        </div>
}

export const Gallery2 = (props:IGalleryProps) : JSX.Element => { 
    const [imageP, setImageP] = useState<number[]>([])
    const [refWidth, setRedWidth] = useState<number>(100)
    const start:number = props.start || 0
    const ref = useRef(null)
    useEffect(() => {
        const widths: number[] = []
        const height: number[] = []
        const p: number[] = []
        props.gallery.forEach( (g, i) => { 
            var img = new Image();
            img.onload = function() { 
                if(!this) return
                const _this: any = this as any 
                widths.push( _this.width ) 
                height.push( _this.height )
                p.push(_this.width / _this.height)  
                setImageP( p )
             }
            img.src = g!
        }) 
        const _ref: any  = ref.current as any
        setRedWidth( _ref.offsetWidth )
    }, [])
    return <div className="vk-gallery" ref={ref} style={{gap: props.gap}}>
        {
            props.gallery.map((g, i) => { 
                const width: number = refWidth * imageP[i] / imageP.reduce((s, a) => s + a, 0) || 0 
                return <GalleryItem
                    key={i}
                    url={g! }
                    i={start + i}
                    type="image"
                    galleryId=""
                    gallery={[]}
                    width={ width }
                    height={ width / imageP[i] || 0 }
                    to={props.to}
                    animated={ props.animated }  
                    animated_delay={props.animated_delay}
                    
                />
            })
        }
    </div>
}
export const Gallery = (props:IGalleryProps) : JSX.Element => { 
    const [imageP, setImageP] = useState<number[]>([])
    const [refWidth, setRedWidth] = useState<number>(100)
    const start:number = Number(props.start) || 0
    const ref = useRef(null)
    useEffect(() => {
        const widths: number[] = []
        const height: number[] = []
        const p: number[] = []
        props.gallery.forEach( (g, i) => { 
            var img = new Image();
            img.onload = function() { 
                if(!this) return
                const _this: any = this as any 
                widths.push( _this.width ) 
                height.push( _this.height )
                p.push(_this.width / _this.height)  
                setImageP( p )
             }
            img.src = g!
        }) 
        const _ref: any  = ref.current as any
        setRedWidth( _ref.offsetWidth )
    }, []) 
    const more: boolean = props.gallery.length > 6
    const _w = more ? refWidth - 100 : refWidth 
    return  more
        ?
        imageP[0] > 1
            ?
            <div ref={ref}  className="d-flex flex-column " style={{gap: props.gap}}>
                <Gallery1 gallery={ [ props.gallery[0] ] }  to={props.to} start={start}  animated={props.animated}  animated_delay={props.animated_delay}  gap={props.gap} />
                <GalleryMore gallery={ props.gallery.slice(1, -1) }  to={props.to} start={start + 1}  animated={props.animated}  animated_delay={props.animated_delay}  gap={props.gap} />
            </div>
            :
            <div ref={ref}  className="d-flex flex-column " style={{gap: props.gap}}>
                <Gallery2 gallery={ [ props.gallery[0], props.gallery[1] ] } start={start}  to={props.to} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
                <GalleryMore gallery={ props.gallery.slice(2, -1) }  start={start + 2} to={props.to} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            </div>
        :
        <div className="vk-gallery" ref={ref}>
            {
                props.gallery.map((g, i) => { 
                    const width: number = _w * imageP[i] / imageP.reduce((s, a) => s + a, 0)  
                    //return <img src={g} key={i} alt={g} style={{ width }} className="thumbnail" />
                    return <GalleryItem
                        key={i}
                        url={g! }
                        i={start + i}
                        type="image"
                        galleryId=""
                        gallery={[]} 
                        width={ width }
                        height={ width / imageP[i] }
                        to={props.to}
                        animated={props.animated}  
                        animated_delay={props.animated_delay}
                    />
                })
            }
            {
                more && <div className="thumb-tile-btn">
                    ...
                </div>
            }
        </div>
    
}
export const GalleryMore = (props:IGalleryProps) : JSX.Element => { 
    const start:number = Number(props.start) || 0
    const ref = useRef(null)
    const count = 5
    const [imageP, setImageP] = useState<number[]>([])
    const [refWidth, setRedWidth] = useState<number>(100)
    useEffect(() => {
        const widths: number[] = []
        const height: number[] = []
        const p: number[] = []
        props.gallery.forEach( (g, i) => { 
            var img = new Image();
            img.onload = function() { 
                if(!this) return
                const _this: any = this as any 
                widths.push( _this.width ) 
                height.push( _this.height )
                p.push(_this.width / _this.height)  
                setImageP( p )
             }
            img.src = g!
        }) 
        const _ref: any  = ref.current as any
        setRedWidth( _ref.offsetWidth )
    }, []) 
    const more: boolean = props.gallery.length > count
    const _w = more ? refWidth - 100 : refWidth
    return <div className="vk-gallery" ref={ref} style={{gap: props.gap}}>
            {
                props.gallery.map((gUrl, i) => { 
                    const _ip = imageP.length <= count ? imageP : imageP.slice(1, count + 1 )
                    const width: number = _w * imageP[i] / _ip.reduce((s, a) => s + a, 0) || 0   
                    return i < count
                        ?
                        <GalleryItem
                            key={ i }
                            url={ gUrl! }
                            i={start + i}
                            type="image"
                            galleryId=""
                            gallery={[]}                            
                            width={ width }
                            height={ width / imageP[i] || 0}
                            to={props.to}
                            animated={props.animated}  
                            animated_delay={props.animated_delay}
                        />
                        :
                        <Fragment key={ i }></Fragment>
                })
            }
            {
                more && <div className="thumb-tile-btn" onClick={() => props.to( count )} >
                    + {props.gallery.length - count}
                </div>
            }
        </div>
    
}

export const Gallery3 = (props:IGalleryProps) : JSX.Element => { 
    const [imageP, setImageP] = useState<number[]>([])
    const [refWidth, setRedWidth] = useState<number>(100)
    const start:number = 0 // props.start || 0
    const ref = useRef(null)
    useEffect(() => {
        const widths: number[] = []
        const height: number[] = []
        const p: number[] = []
        props.gallery.forEach( (g, i) => { 
            var img = new Image();
            img.onload = function() { 
                if(!this) return
                const _this: any = this as any 
                widths.push( _this.width ) 
                height.push( _this.height )
                p.push(_this.width / _this.height)  
                setImageP( p )
             }
            img.src = g!
        }) 
        const _ref: any  = ref.current as any
        setRedWidth( _ref.offsetWidth)
    }, [])
    return <div className="vk-gallery" ref={ref} style={{gap: props.gap}}>
        {
            imageP[0] > 1 && !props.forceLine
                ?
                <div className="d-flex flex-column " style={{gap: props.gap}}>
                    <Gallery1 gallery={[ props.gallery[0] ]} to={props.to} start={start} gap={props.gap} />
                    <Gallery2 gallery={[ props.gallery[1], props.gallery[2] ]} to={props.to} start={start + 1}  gap={props.gap} />
                </div>                
                :
                props.gallery.map((g, i) => { 
                    const width: number = refWidth * imageP[i] / imageP.reduce((s, a) => s + a, 0)  || 0 
                    return <GalleryItem
                        key={i}
                        url={g! }
                        i={start + i}
                        type="image"
                        galleryId=""
                        gallery={[]}                        
                        width={ width }
                        height={ width / imageP[i] || 0 }
                        to={props.to}
                        animated={props.animated}  
                        animated_delay={props.animated_delay}
                    />
                })
        }
    </div>
}

export const Gallery4 = (props:IGalleryProps) : JSX.Element => {
    const [isVertical, setIsVertical] = useState<boolean>(false)
    const start:number = props.start || 0
    useEffect(() => { 
        var img = new Image();
        img.onload = function() { 
            if(!this) return
            const _this: any = this as any 
            setIsVertical( _this.width / _this.height  > 1 ) 
        }
        img.src = props.gallery[0]!
    }, [])
    return props.forceLine
        ?
        <Gallery gallery={ props.gallery } to={props.to} start={start} animated={props.animated}  animated_delay={props.animated_delay}/>
        :
        isVertical
            ?
            <div  className="position-relative d-flex flex-column" style={{gap:props.gap}}>
                <Gallery1 gallery={ [ props.gallery[0] ] } to={props.to} start={start} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
                <Gallery3 gallery={ [ props.gallery[1], props.gallery[2], props.gallery[3] ]} to={props.to} start={start+1} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            </div>
            :
            <div  className="position-relative d-flex flex-column" style={{gap:props.gap}}>
                <Gallery2 gallery={[props.gallery[0], props.gallery[1]]} to={props.to} start={start} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
                <Gallery2 gallery={[props.gallery[2], props.gallery[3]]} to={props.to} start={start+2}animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
            </div>
}

export const Gallery4Mini = (props:IGalleryProps) : JSX.Element => {
    const [imageP, setImageP] = useState<number[]>([])
    const [refWidth, setRedWidth] = useState<number>(100)
    const start:number = props.start || 0
    const ref = useRef(null)
    useEffect(() => {
        const widths: number[] = []
        const height: number[] = []
        const p: number[] = []
        props.gallery.forEach( (g, i) => { 
            var img = new Image();
            img.onload = function() { 
                if(!this) return
                const _this: any = this as any 
                widths.push( _this.width ) 
                height.push( _this.height )
                p.push(_this.width / _this.height)  
                setImageP( p )
             }
            img.src = g!
        }) 
        const _ref: any  = ref.current as any
        setRedWidth( _ref.offsetWidth )
    }, [])
    return <div className="vk-gallery" ref={ref}>
        {
            props.gallery.map((g, i) => { 
                const width: number = refWidth * imageP[i] / imageP.reduce((s, a) => s + a, 0)   || 0
                return <GalleryItem
                    key={i}
                    url={g! }
                    i={start + i}
                    type="image"
                    galleryId=""
                    gallery={[]}                    
                    width={ width }
                    height={ width / imageP[i] || 0 }
                    to={props.to}
                    animated={props.animated}  
                    animated_delay={props.animated_delay}
                />
            })
        }
    </div>
}

export const Gallery5 = (props:IGalleryProps) : JSX.Element => {
    const [isVertical, setIsVertical] = useState<boolean>(false)
    const start:number = Number(props.start) || 0
    useEffect(() => { 
        var img = new Image();
        img.onload = function() { 
            if(!this) return
            const _this: any = this as any 
            setIsVertical( _this.width / _this.height  > 1 ) 
        }
        img.src = props.gallery[0]!
    }, [])
    return isVertical
    ?
    <div className="position-relative d-flex flex-column" style={{gap:props.gap}}>
        <Gallery1 gallery={[props.gallery[0], ]} to={props.to} start={start} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
        <Gallery4Mini gallery={[props.gallery[1], props.gallery[2], props.gallery[3], props.gallery[4], props.gallery[5]]} to={props.to} start={start + 1} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
    </div>
    : 
    <div className="position-relative d-flex flex-column" style={{gap:props.gap}}>
        <Gallery2 gallery={[props.gallery[0], props.gallery[1], ]} to={props.to} start={start} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
        <Gallery3 gallery={[props.gallery[2], props.gallery[3], props.gallery[4], props.gallery[5]]} forceLine to={props.to} start={2} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
    </div>
}

export const Gallery6 = (props:IGalleryProps) : JSX.Element => {    
    const start:number = props.start || 0
    return <div className="position-relative d-flex flex-column" style={{gap:props.gap}}>
        <Gallery3 gallery={[props.gallery[0], props.gallery[1], props.gallery[2]]} forceLine to={props.to} start={start} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
        <Gallery3 gallery={[props.gallery[3], props.gallery[4], props.gallery[5]]} forceLine to={props.to} start={3+start} animated={props.animated}  animated_delay={props.animated_delay} gap={props.gap} />
    </div>
}
